import React from 'react';
import {Link} from 'react-router';
import CenteredImageContainer from "../CenteredImageContainer";
import {getResourceImageUrl} from "../../actions/networkActions";
import Price from "../Price";
import { useLingui } from '@lingui/react/macro';
import { useSelector } from 'react-redux';

function CartElementCheckout(props) {
    const currencySymbol = useSelector((state)=>state.cart.currencySymbol);
    const {t} = useLingui();
    return(
        <div className="flex flex-wrap bg-white border border-primary shadow my-6">
            {/* image */}
            <div className="w-full sm:w-1/2 md:w-1/3 sm:p-4">
                <CenteredImageContainer
                    alt={props.name + " cover"}
                    src={getResourceImageUrl(props.imageReference, {width: 400, category:props.imageCategory})}
                />
            </div>

            {/* rest of card */}
            <div className="flex flex-col p-4 w-full sm:w-1/2 md:w-2/3">

                {/*Link and card content*/}
                <div className="grow">
                    <Link 
                        className="text-primary underline text-2xl uppercase" 
                        to={{pathname: props.linkTo.pathname}}
                        state={props.linkTo.state}
                    >
                        {props.name}
                    </Link>

                    <div className="mt-2">
                        {props.children}
                    </div>
                </div>

                {/* cost info */}
                <div className="text-right mt-2">
                    {props.status === "Waitlisted" &&
                    <div>
                        <div className={`inline-block text-primary-dark bg-primary-lighter p-3 mb-2 uppercase`}>
                            {props.status === "Bookable" ? t({id: "not_reserved"}) : t({id: "waitlist_not_reserved"})}
                        </div>
                        <Price classes="sm:leading-negative mb-2" preText={`${t({id: "waitlist_cost"})} :`} price={0} currencySymbol={currencySymbol} />
                    </div>
                    }
                    <Price classes="sm:leading-negative" preText={props.pricePreText} price={props.price} currencySymbol={currencySymbol}/>
                </div>
            </div>
        </div>
    )
}

export default CartElementCheckout;